<template>
    <div>
        <Row :gutter="16">

            <Layout>
                <Content style="min-width:500px;margin:0 8px">
                    <Card>
                        <p slot="title">{{t.routerName}}</p>
                        <Row>
                            <Col>
                                <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                      ref="form">
                                    <FormItem :label="t.user.deptName" prop="deptName">
                                        <Select v-model="formItem.deptId"
                                                :placeholder="msgUtil.placeholderSelected(t.user.deptName)">
                                            <Option :value="item.id" :key="item.id" v-for="item in deptList">
                                                {{item.name}}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem :label="t.user.name" prop="name">
                                        <Input v-model="formItem.name" :maxlength="16"
                                               :placeholder="msgUtil.placeholderRequired(t.user.name)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.email" prop="email">
                                        <Input v-model="formItem.email" :maxlength="70"
                                               :placeholder="msgUtil.placeholderRequired(t.user.email)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.mobile" prop="mobile">
                                        <Input v-model="formItem.mobile" :maxlength="15"
                                               :placeholder="msgUtil.placeholderRequired(t.user.mobile)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.type" prop="type">
                                        <Select v-model="formItem.type"
                                                :placeholder="msgUtil.placeholderSelected(t.user.type)">
                                            <Option value="0">{{t.user.normalUser}}</Option>
                                            <Option value="1">{{t.user.members}}</Option>
                                            <Option value="2">{{t.user.systemUser}}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem :label="t.user.sex" prop="sex">
                                        <i-switch v-model="formItem.sex" size="large" true-value="0" false-value="1">
                                            <span slot="open">{{t.user.male}}</span>
                                            <span slot="close">{{t.user.female}}</span>
                                        </i-switch>
                                    </FormItem>
                                    <FormItem :label="t.user.status" prop="status">
                                        <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                            <span slot="open">{{t.user.open}}</span>
                                            <span slot="close">{{t.user.close}}</span>
                                        </i-switch>
                                    </FormItem>
                                    <FormItem :label="t.user.remark" prop="remark">
                                        <Input v-model="formItem.remark" :maxlength="200"
                                               :autosize="{minRows: 12,maxRows: 30}"
                                               :placeholder="msgUtil.placeholderRequired(t.user.remark)"
                                               type="textarea"></Input>
                                    </FormItem>
                                    <FormItem style="margin-bottom:40px;">
                                        <Button type="primary" :loading="loading" @click="handleSubmit()">
                                            {{msgUtil.message.action.submit}}
                                        </Button>
                                        <Button @click="handleReset()" style="margin-left: 8px">
                                            {{msgUtil.message.action.reset}}
                                        </Button>
                                    </FormItem>
                                </Form>
                            </Col>
                        </Row>
                    </Card>
                </Content>
                <Sider hide-trigger width="400" style="background:transparent;margin:0 8px">
                    <Form :model="formItem" :rules="ruleValidate" ref="form1">
                        <Row>
                            <Card>
                                <div class="img-drag" @click="changeCropper">
                                    <div v-if="formItem.avatar === ''" class="upload_img" style="padding: 120px 0">
                                        <Icon type="ios-cloud-upload" size="120" style="color: #3399ff"></Icon>
                                        <p>{{msgUtil.message.file.uploadImg}}</p>
                                    </div>
                                    <div v-else>
                                        <img :src="formItem.avatar" class="upload_img"/>
                                    </div>
                                </div>
                                <FormItem prop="loginName" style="margin-top:10px;">
                                    <Input type="text" v-model="formItem.loginName" readonly>
                                        <Icon type="ios-person-outline" slot="prepend"></Icon>
                                    </Input>
                                </FormItem>
                                <FormItem>
                                    <transition name="fade" mode="out-in">
                                        <Button type="warning" v-if="show===false" long @click="changePassword">
                                            {{msgUtil.message.action.changePwd}}
                                        </Button>
                                        <FormItem prop="password" v-if="show===true" style="margin-bottom:1px">
                                            <Input type="text" v-model="formItem.password" :maxlength="25"
                                                   :placeholder="msgUtil.placeholderRequired(t.user.password)">
                                                <Icon type="ios-lock-outline" slot="prepend"></Icon>
                                                <Button slot="append" @click="handlePwdRandom()">
                                                    {{msgUtil.message.action.random}}
                                                </Button>
                                                <Button slot="append" @click="changePassword">
                                                    {{msgUtil.message.action.cancel}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                    </transition>
                                </FormItem>
                                <Alert show-icon>{{t.info.accountNotChange}}</Alert>
                            </Card>
                        </Row>
                        <Row class="margin-top-10">
                            <Card>
                                <p slot="title">
                                    <Icon type="logo-buffer"/>
                                    {{t.role.roleDistribute}}
                                </p>
                                <!--<Checkbox-group v-model="formItem.roleIdList" style="height:270px;overflow-y: scroll;">
                                    <div style="margin: 0 0 15px 20px" :key="item.id"
                                         v-for="item in roleList">
                                        <Checkbox :label="item.id">{{item.name}}</Checkbox>
                                    </div>
                                </Checkbox-group>-->
                                <FormItem :label="t.user.postName" prop="postIdList">
                                    <Select v-model="formItem.postIdList" multiple
                                            :placeholder="msgUtil.placeholderSelected(t.user.postName)">
                                        <Option v-for="item in postList" :value="item.id" :key="item.id">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                </FormItem>
                                <FormItem :label="t.user.roleName" prop="roleIdList">
                                    <Select v-model="formItem.roleIdList" multiple
                                            :placeholder="msgUtil.placeholderSelected(t.user.roleName)">
                                        <Option v-for="item in roleList" :value="item.id" :key="item.id">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Card>
                        </Row>
                    </Form>
                </Sider>
            </Layout>
        </Row>
        <Modal
            :title='msgUtil.message.action.changePic'
            v-model="modalManage.avatarModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="resetCropperModal">
            <Row>
                <div class="content">
                    <div class="sub-cropper">
                        <vueCropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.outputSize"
                            :outputType="option.outputType"
                            :info="option.info"
                            :full="option.full"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :fixedBox="option.fixedBox"
                            :original="option.original"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :centerBox="option.centerBox"
                            :high="option.high"
                            :infoTrue="option.infoTrue"
                            @realTime="realTime"
                            @imgLoad="imgLoad"
                            @cropMoving="cropMoving"
                            :enlarge="option.enlarge"
                        ></vueCropper>
                    </div>
                </div>
            </Row>
            <Row>
                <Col style="text-align:right;">
                    <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                            style="display:inline-block;margin-right: 10px;">
                        <Button icon="ios-cloud-upload-outline">
                            {{msgUtil.message.action.picSelect}}
                        </Button>
                    </Upload>
                    <Button v-if="option.img != null && option.img !== ''" type="primary" @click="handleUpload">
                        {{msgUtil.message.action.upload}}
                    </Button>
                    <Button v-else type="primary" disabled>
                        {{msgUtil.message.action.upload}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import { edit, getUserInfo } from '@/api/user';
import { getDeptList } from '@/api/dept';
import { getPostList } from '@/api/post';
import { getRoleList } from '@/api/role';
import { VueCropper } from 'vue-cropper';
import { uploadImg } from '@/api/image';

export default {
    name: 'organization_user_edit',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            option: {
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 360,
                autoCropHeight: 360,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            formItemBk: {},
            formItem: {
                avatar: '',
                deptId: '',
                loginName: '',
                password: '',
                passwordAgain: '',
                name: '',
                email: '',
                mobile: '',
                sex: '0',
                status: '1',
                type: '0',
                remark: '',
                postIdList: [],
                roleIdList: [],
            },
            correlateObject: {
                status: '1',
                size: '99999',
            },
            modalManage: {
                avatarModal: false,
                passwordModal: false,
            },
            deptList: [],
            postList: [],
            roleList: [],
            ruleValidate: {
                deptId: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.deptName),
                        trigger: 'blur',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 16,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.name, 16),
                        trigger: 'blur',
                    },
                ],
                loginName: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.loginName),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 16,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.loginName, 16),
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.password),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[a-zA-Z0-9]+$/,
                        message: msgUtil.placeholderRequiredHalfWidthCharOrNumber(t.user.password),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 25,
                        message: msgUtil.errorMaxLength(t.user.password, 25),
                        trigger: 'blur',
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.mobile),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]*$/,
                        message: msgUtil.errorRequiredHalfWidthNumber(t.user.mobile),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 15,
                        message: msgUtil.errorMaxLength(t.user.mobile, 15),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: msgUtil.errorFormat(t.user.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 70,
                        message: msgUtil.errorMaxLength(t.user.email, 70),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.remark, 200),
                        trigger: 'blur',
                    },
                ],
                postIdList: [
                    {
                        type: 'array',
                        required: true,
                        message: msgUtil.errorRequired(t.user.postName),
                        trigger: 'blur',
                    },
                ],
                roleIdList: [
                    {
                        type: 'array',
                        required: true,
                        message: msgUtil.errorRequired(t.user.roleName),
                        trigger: 'blur',
                    },
                ],
            },
            show: false,
            loading: false,
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            if ((await this.$refs['form1'].validate()) && (await this.$refs['form'].validate())) {
                let userDto = {};
                userDto.avatar = this.formItem.avatar;
                userDto.deptId = this.formItem.deptId;
                userDto.email = this.formItem.email;
                userDto.loginName = this.formItem.loginName;
                userDto.mobile = this.formItem.mobile;
                userDto.name = this.formItem.name;
                userDto.password = this.formItem.password;
                userDto.sex = this.formItem.sex;
                userDto.status = this.formItem.status;
                userDto.type = this.formItem.type;
                userDto.remark = this.formItem.remark;
                userDto.postIdList = this.formItem.postIdList;
                userDto.roleIdList = this.formItem.roleIdList;
                await edit(this.$route.params.id, userDto);
                Object.assign(this.formItemBk, this.formItem);
                this.$Loading.finish();
                this.$Message.success(this.msgUtil.message.action.updateSuccess);
            } else {
                this.$Loading.error();
                this.$Message.error(this.msgUtil.message.action.updateFail);
            }
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.$refs.form1.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
            this.show = false;
        },
        changePassword() {
            this.show = !this.show;
            this.formItem.password = '';
        },
        //随机数
        getRandomString(len) {
            len = len || 16;
            const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
            const maxPos = $chars.length;
            let pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        async handlePwdRandom() {
            this.formItem.password = await this.getRandomString(10);
            this.show = false;
            this.show = true;
        },
        changeCropper() {
            this.option.img = this.formItem.avatar;
            this.modalManage.avatarModal = true;
        },
        resetCropperModal() {
            // this.$Loading.finish();
        },
        // 实时预览函数
        realTime(data) {
            let previews = data;
            let h = 0.5;
            let w = 0.2;
            this.previewStyle1 = {
                width: previews.w + 'px',
                height: previews.h + 'px',
                overflow: 'hidden',
                margin: '0',
                zoom: h,
            };
        },
        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }

            const reader = new FileReader();
            reader.onload = e => {
                let data;
                //console.log(e);
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    this.formItem.avatar = BaseUrl.Url + d.url;
                    this.modalManage.avatarModal = false;
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
        async init() {
            //得到所有部门
            const depts = await getDeptList(this.correlateObject);
            //console.log(depts);
            if (depts.page != null) {
                this.deptList = depts.page.records;
            }
            //得到所有岗位
            const posts = await getPostList(this.correlateObject);
            if (posts.page != null) {
                this.postList = posts.page.records;
            }
            //得到所有角色
            const roles = await getRoleList(this.correlateObject);
            if (roles.page != null) {
                this.roleList = roles.page.records;
            }
            const userInfo = await getUserInfo(this.$route.params.id);
            if (userInfo.user != null) {
                this.formItem = userInfo.user;
                Object.assign(this.formItemBk, userInfo.user);
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    width: 362px;
    height: 362px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.content {
    max-width: 800px;
    margin-bottom: 10px;
}

.sub-cropper {
    height: 400px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1000px) {
    .content {
        max-width: 100%;
        /* margin: auto;*/
    }

    .sub-cropper {
        height: 400px;
    }
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
